import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';
import { connect } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import moment from 'moment';

import {
  TextArea,
  Progress,
  Form,
  Portal,
  Segment,
  Loader,
} from 'semantic-ui-react';

import {
  fetchSummary,
  createSummary,
  updateSummary,
  deleteSummary,
} from '../../actions/summary';

import { fetchRawRating } from '../../actions/rating';

import {
  QualiHeading,
  AutoSummary,
  NotGeneratedYet,
  RatingIncomplete,
  SummaryEditor,
  BrandSummaryRating,
} from '../../components';
import './BrandSummary.css';

const moments = date => moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss a');

class BrandSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      isGeneratingSummary: false,
      renderSummary: '',
      progressBar: 0,
      brandId: this.props.match.params.id,
    };

    this.handleNav = this.handleNav.bind(this);
    this.handlePortal = this.handlePortal.bind(this);
  }

  // calls API to receive currently saved contact details for brand
  componentWillMount() {
    this.props.fetchSummary(this.state.brandId);
    this.props.fetchRawRating(this.state.brandId);
  }

  // when component receives props with data from API, will set details to be managed in state
  componentWillReceiveProps(nextProps) {
    if (nextProps.summary.error) {
      this.setState({ error: nextProps.summary.error.toString() });
      toast.error(nextProps.summary.error.toString());
    }
    
    if (nextProps.summary !== this.props.summary) {
      _.map(nextProps.summary.summaries, (summary) => {
        this.setState({
          renderSummary: summary.text,
          rating_status: summary.rating_status,
          text_status: summary.text_status,
          summaryDate: summary.createdAt,
        });

        if (summary.text) {
          summary.text === '' ? this.setState({ progressBar: 0 }) : this.state.progressBar++;
        }
      });

      this.setState({ isLoading: nextProps.summary.isFetching });
    }
  }

  // toggles editing mode for specified question
  handleEdit() {
    this.setState({ isEditing: true });
  }

  // clears all errors in state and recalls API to ensure all data displayed to user is up to date
  handleCancel(event) {
    this.setState({
      isEditing: false,
      isLoading: true,
      isGeneratingSummary: false,
    });
    this.props.fetchSummary(this.state.brandId);
  }

  // if the currently selected summary already exists in props, will send PATCH request to API, otherwise will send POST.

  handleSaveSummary(summaryText) {
    this.setState({
      isEditing: false,
      isGeneratingSummary: false,
    });

    // yes, always summary from props will be an Array cause API BE decisions.
    const summary = this.props.summary.summaries[0];
    
    if (summary.id) {
      this.props.updateSummary(summary.id, { brandId: this.state.brandId, text: summaryText });
      this.state.renderSummary === '' ? this.setState({ progressBar: 0 }) : this.state.progressBar++;
    } else {
      this.props.createSummary({ brand: this.state.brandId, text: summaryText });
      this.state.renderSummary === '' ? this.setState({ progressBar: 0 }) : this.state.progressBar++;
    }
  }

  handleSaveSummaryAndNext(summary) {
    this.handleSaveSummary(summary);
    this.props.history.push(`/brandLanding/${this.state.brandId}`);
  }

  // renders ratings that have been completed in ratings sections
  renderRawRatings() {
    if (this.props.pre_qa) {
      if (this.props.pre_qa.length > 0) {
        let count = 0;
        return _.map(this.props.pre_qa, answer => {
          return (
            <div key={count++}>{answer.text}</div>
          );
        });
      } else {
        return <p>There is no answer at the rating section yet</p>;
      }
    }
  }

  // close portal upon clicking Go button
  handlePortal() {
    this.setState({ portal: false });
  }

  // handles navigation between pages to prevent users from leaving current page while they are currently editing a question.
  handleNav(event) {
    if (this.state.changeError === true) {
      this.setState({ renderChangeError: true, portal: true });
    } else {
      if (event.target.name === 'previous') {
        this.props.history.push(`/brandSentences/${this.state.brandId}`);
      } else if (event.target.name === 'next') {
        this.props.history.push(`/suppDataSocialMedia/${this.state.brandId}`);
      } else if (event.target.name === 'landing') {
        this.props.history.push(`/brandLanding/${this.state.brandId}`);
      }
    }
  }

  // set flags for generating summary
  generateSummary() {
    this.setState({ isGeneratingSummary: true });
  }

  doneSummary() {
    this.setState({ isGeneratingSummary: false });
  }

  navigateTo(route) {
    switch (route) {
    case 'brandPage':
      this.props.history.push(`/brandLanding/${this.state.brandId}`);
      break;
    case 'ratingPage':
      this.props.history.push(`/env-standards-compliance/${this.state.brandId}`);
      break;
    default:
    }
  }

  // render contains conditional statements based on state of isEditing as described in functions above.
  render() {
    return (
      <div className='form-container'>
        <QualiHeading id={this.state.brandId} brand={this.props.brand} />
        <div className='forms-header'><button onClick={this.handleNav} name='landing'>Back to Summary</button></div>
        <div className='forms-header'>
          <span className='form-navigation'>
            <div><button onClick={this.handleNav} name='previous' className='previous'>Previous</button></div>
            <div><h3>Brand Summary</h3></div>
            <div><button onClick={this.handleNav} name='next' className='next'>Next</button></div>
          </span>
        </div>
        <p className='small-divider' />
        <h5> Current:</h5>
        <Progress total={1} value={this.state.progressBar} progress />
        {this.state.renderChangeError === true ? (
          <Portal open={this.state.portal} className='portal'>
            <Segment style={{ left: '35%', position: 'fixed', top: '50%', zIndex: 1000 }}>
              <p>Please Save or Cancel your selected answers before proceeding</p>
              <HashLink to={this.state.currentEditing}><button onClick={this.handlePortal}>Go</button></HashLink>
            </Segment>
          </Portal>
        ) : ''}
        <BrandSummaryRating { ...this.props.summary[0] } ></BrandSummaryRating>
        
        {this.state.isLoading === true ? <Loader active inline='centered' />
          : <div className="autosummary-container">
            {this.state.rating_status === 'incomplete'
              && <RatingIncomplete
                title={"The Brand Rating needs to be completed before generating an Auto Summary"}
                onBackBrandPage={() => this.navigateTo('brandPage')}
                onBackRating={() => this.navigateTo('ratingPage')}
              />
            }

            {this.state.rating_status === 'complete' && this.state.text_status === 'none'
              && <NotGeneratedYet
                title={"No automated summary has been generated yet, do you want to generate one?"}
                onGenerate={() => this.generateSummary()}
                onBackBrandPage={() => this.navigateTo('brandPage')}
              />
            }

            {this.state.rating_status === 'complete' && this.state.text_status === 'incomplete'
              && (
                <div>
                  <Segment color='red'>
                    A change in the Rating has been made, do you want to generate a new automated summary?
                  </Segment>
                  {!this.state.isEditing && !this.state.isGeneratingSummary
                    && (
                      <div className='button-block'>
                        <button onClick={() => { this.handleEdit(); }}>Edit Current Summary</button>
                        <button className='float-left' onClick={() => { this.generateSummary(); }}>Generate AutoSummary</button>
                      </div>
                    )
                  }
                </div>
              )
            }

            {this.state.rating_status === 'complete' && this.state.text_status === 'complete'
              && (
                <div>
                  <h5>Last Saved Summary</h5>
                  <Form>
                    <TextArea rows={8} readOnly value={this.state.renderSummary}/>
                    <p>Updated At: <strong>{moments(this.state.summaryDate)}</strong></p>
                  </Form>
                  
                  {this.state.isEditing
                    ? <SummaryEditor
                      title='Summary Editor'
                      originalText={ this.state.renderSummary }
                      onSave={ newSummary => this.handleSaveSummary(newSummary) }
                      onSaveAndNext={ newSummary => this.handleSaveSummaryAndNext(newSummary) }
                      onCancel={ () => this.handleCancel() }
                    >
                    </SummaryEditor>
                    : !this.state.isGeneratingSummary
                      && (
                        <div className='button-block'>
                          <button onClick={() => { this.handleEdit(); }}>Edit Current Summary</button>
                          <button className='float-left' onClick={() => { this.generateSummary(); }}>Generate AutoSummary</button>
                        </div>
                      )
                  }
                </div>
              )
            }

            {this.state.isGeneratingSummary
              && <AutoSummary
                brandId={ this.state.brandId }
                onSave={ summaryText => this.handleSaveSummary(summaryText) }
                onSaveAndNext={ summaryText => this.handleSaveSummaryAndNext(summaryText) }
                onCancel={ () => this.handleCancel() }
              />
            }
          </div>
        }

        <div className='not-editing'>
          <p className='small-divider' />
          <h4>Rating Answers</h4>
          {this.renderRawRatings()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    summary: state.summary,
    pre_qa: state.preQa,
    brand: state.brandInfo,
    error: state.error,
  };
}

export default connect(mapStateToProps, { updateSummary, fetchSummary, createSummary, fetchRawRating })(BrandSummary); 


// WEBPACK FOOTER //
// ./src/pages/brandSummary/BrandSummary.js